import { createFcmHook } from 'src/app/shared/hooks/fcm';

import { FCM_EXPERIMENT_DS2 } from './config';

export const useDs2ExperimentFcm = createFcmHook(FCM_EXPERIMENT_DS2.fcmConfigs);
